<template>
  <image-header-page class="image-header-page padding-bottom-xl" :image-header-props="imageHeaderProps">
    <template v-slot:header>
      <div class="header-text flex-column full-height full-width align-right header-container" >
        <div class="header-text ri-body margin-top-sm flex-row align-center">
          <img :src="require('@/assets/icons/mortgages-flower.svg')" class="margin-bottom-xxs margin-left-xxs"/>
          המשכנתא של {{householdName}}
        </div>
        <div class="ri-medium-bold-display margin-top-l">
          <span>מיחזור משכנתא יכול</span>
          <span class="yellow-text">לחסוך עשרות אלפי שקלים.</span>
          <span>רייזאפ לוקחת אותך לשם יד ביד.</span>
        </div>
        <div class="ri-body text-right">
            <div v-if="mortgageSource === 'Report' && oldMortgageBalanceDate" class="ri-body margin-top-m  margin-bottom-m black-text">
              <div class="basic-label ri-label" :style="{background: '#E8F4BA'}">
                <icon icon-name="error" size="24px" color="black" :optical-size="24" class="margin-left-s"/>
                  <div>
                    <div>מבוסס על דוח משכנתא ישן מתאריך {{ updatedAtDate }}.</div>
                    <div>כדי להעלאת דוח מעודכן
                      <span class="clickable-text" @click="onUpdateReportClick">אפשר ללחוץ כאן</span>
                    </div>
                </div>
              </div>
            </div>
            <div v-else-if="mortgageBalanceDate" class="ri-body margin-top-m  margin-bottom-m">
              {{ mortgageBalanceDateText }}
            </div>
          </div>
    </div>
    </template>
    <template v-slot:overlayContent>
        <card class="cards-container mortgage-alternative-card padding-vertical-ml">
          <div class="flex-column">
            <div class="image-container margin-bottom-ml">
              <img :src="require('@/assets/mortgage-total.svg')" class="alternative-image" />
            </div>
            <div class="flex-column card-text">
              <div class="ri-body">{{recycleMortgageText}}</div>
            </div>
          </div>
          <riseup-button class="mortgage-btn margin-top-l"
                         :class="{'mortgage-without-data-advisory-chat': hasMortgageData}" :title="buttonTitle" color="green"
                         :loading="loadingIntercom"
                         @click="onCheckAlternativeClick" />
        </card>
        <div class="ri-body margin-top-l footer-text" @click="goToNewMortgagePage">אין לי משכנתא אבל כנראה שאקח אחת</div>
      </template>
    </image-header-page>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import { mapActions, mapGetters, mapState } from 'vuex';
import Segment from '@/Segment';
import router from '@/router';
import config from '@/config';
import moment from 'moment';

export default {
  name: 'NoMortgageAlternativesPage',
  components: {
    Card: BaseUI.Card,
    RiseupButton: BaseUI.RiseupButton,
    ImageHeaderPage: BaseUI.Pages.ImageHeaderPage,
    Icon: BaseUI.Icon,
  },
  data() {
    return {
      loadingIntercom: false,
    };
  },
  created() {
    Segment.trackUserInteraction('NoMortgageAlternativesPage_Entered');
    this.setAppHeaderProps({
      backgroundColorVariant: BaseUI.LayoutConsts.COLOR_VARIANT.GREEN,
      textColor: BaseUI.Colors.riseupLightGreen,
      logoColor: BaseUI.Colors.riseupLightGreen,
    });
  },
  computed: {
    ...mapGetters('session', ['householdName']),
    ...mapState('session', ['customerId']),
    ...mapGetters('otsState', ['isInOtsFlow']),
    ...mapGetters('mortgages', ['hasMortgageData', 'reportGeneratedDate', 'mortgageSource', 'createdAt']),
    imageHeaderProps() {
      const imgHeight = (this.mortgageSource === 'Report' && this.oldMortgageBalanceDate) ? 396 : 360;
      return {
        backgroundColor: BaseUI.LayoutConsts.COLOR_VARIANT.GREEN,
        bottomSeparator: false,
        textColor: BaseUI.Colors.riseupDarkGreen,
        backgroundPosition: BaseUI.LayoutConsts.BACKGROUND_POSITIONS.BOTTOM_LEFT,
        imgHeight,
      };
    },
    recycleMortgageText() {
      if (this.hasMortgageData) {
        return 'המשכנתא שלך נראית טוב! אין לנו הצעות שיפור בשבילה כרגע. נמשיך להיות על זה ונעדכן אם נמצא דרכים לשפר אותה';
      }

      return 'אין לנו נתונים על המשכנתא שלך עדיין. רוצה שנבדוק כמה אפשר לחסוך עליה?';
    },
    buttonTitle() {
      if (this.hasMortgageData) {
        return 'רוצה בכל זאת לדבר? אנחנו כאן';
      }

      return 'כן, בואו נבדוק';
    },
    updatedAtDate() {
      if (!this.mortgageBalanceDate) {
        return '';
      }
      return moment(this.mortgageBalanceDate).format('DD.MM.YY');
    },
    updatedAtHour() {
      if (!this.mortgageBalanceDate) {
        return '';
      }
      return moment(this.mortgageBalanceDate).format('HH:mm');
    },
    mortgageBalanceDate() {
      if (this.mortgageSource === 'Report') {
        return this.reportGeneratedDate;
      }
      return this.createdAt;
    },
    mortgageBalanceDateText() {
      if (this.mortgageSource === 'Report') {
        return `מבוסס על דוח יתרות לסילוק מתאריך: ${this.updatedAtDate}`;
      }
      return `עודכן לאחרונה ב-${this.updatedAtDate} בשעה ${this.updatedAtHour}`;
    },
    oldMortgageBalanceDate() {
      if (this.mortgageSource === 'Report') {
        return moment(new Date()).diff(moment(this.reportGeneratedDate), 'days') > 60;
      }
      return false;
    },
  },
  methods: {
    ...mapActions('appHeader', ['setAppHeaderProps']),
    onCheckAlternativeClick() {
      if (this.hasMortgageData) {
        Segment.trackUserInteraction('NoMortgageAlternativesPage_GoodEnough_CheckClicked', { hasMortgageData: this.hasMortgageData });
        window.open(`${config.get().bookAppointmentUrl}?USERID=${this.customerId}`, '_blank');
      } else {
        this.loadingIntercom = true;
        setTimeout(() => {
          this.loadingIntercom = false;
        }, 8000);
        // We send message from Intercom by this event
        Segment.trackUserInteraction('NoMortgageAlternativesPage_CheckClicked', { hasMortgageData: this.hasMortgageData });
      }
    },
    goToNewMortgagePage() {
      Segment.trackUserInteraction('NoMortgageAlternativesPage_WillTakeMortgageClicked', { hasMortgageData: this.hasMortgageData });
      if (this.isInOtsFlow) {
        router.push({ path: '/ots/new-mortgage' });
      } else {
        router.push({ path: '/new-mortgage' });
      }
    },
    onUpdateReportClick() {
      Segment.trackUserInteraction('NoMortgageAlternativesPage_UpdateReportClicked');
      if (this.isInOtsFlow) {
        router.push({ path: '/ots/upload-mortgage-report' });
      } else {
        router.push({ path: '/upload-mortgage-report' });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";
@import "~@riseupil/base-ui/src/scss/spacings";

  .image-header-page {
    background: $riseup_beige;

    .header-text {
      text-align: right;
    }

    .cards-container {
      background-color: $riseup_white;
    }

    .yellow-text {
      color: $riseup_yellow;
    }

    .card-text {
      color: $riseup_dark_green;
      text-align: center;
    }

    .image-container {
      display: flex;
      justify-content: center;
    }

    .footer-text {
      color: $riseup_black;
      text-align: center;
      text-decoration: underline;
      cursor: pointer;
    }

    .mortgage-btn {
      ::v-deep .button-titles {
        white-space: nowrap;
      }
    }

    .basic-label {
      margin-top: 10px;
      width: 100%;
      padding: 10px 12px;
      border-radius: 8px;
      display: flex;
      direction: rtl;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
    }

    .clickable-text {
      color: $riseup_dark_green;
      text-decoration: underline;
      cursor: pointer;
      font-weight: bold;

      &:hover {
        color: darken($riseup_dark_green, 10%);
      }
    }

    .black-text {
      color: $riseup_black;
    }
  }

</style>
